import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import useAuthStore from './store/authStore';
import Layout from './layouts/Layout';
import LoginPage from './pages/auth/LoginPage';
import Dashboard from './pages/Dashboard';
import MedicinesPage from './pages/medicines/MedicinesPage';
import InventoryPage from './pages/inventory/InventoryPage';
import PurchasesPage from './pages/purchases/PurchasesPage';
import SalesPage from './pages/sales/SalesPage';
import CustomersPage from './pages/customers/CustomersPage';
import SuppliersPage from './pages/suppliers/SuppliersPage';
import PatientsPage from './pages/patients/PatientsPage';
import EmployeesPage from './pages/employees/EmployeesPage';
import PrescriptionsPage from './pages/prescriptions/PrescriptionsPage';
import BranchesPage from './pages/branches/BranchesPage';
import UsersPage from './pages/users/UsersPage';
import RolesPage from './pages/users/RolesPage';
import PartnersPage   from './pages/partners/PartnersPage';
import AccountingPage from './pages/accounting/AccountingPage';
import ExpensesPage from './pages/accounting/ExpensesPage';
import ReportsPage from './pages/reports/ReportsPage';
import AuditPage from './pages/audit/AuditPage';
import NotFoundPage from './pages/NotFoundPage';
import MasterDataPage from './pages/masterdata/MasterDataPage';
import BankAccountsPage from './pages/bank/BankAccountsPage';
import RequisitionsPage from './pages/requisitions/RequisitionsPage';
import PurchaseRequestsPage from './pages/purchaseRequests/PurchaseRequestsPage';
import SettingsPage from './pages/settings/SettingsPage';

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated } = useAuthStore();
  return isAuthenticated ? children : <Navigate to="/login" replace />;
};

function App() {
  const { isAuthenticated, fetchMe } = useAuthStore();
  useEffect(() => { if (isAuthenticated) fetchMe(); }, [isAuthenticated, fetchMe]);

  return (
    <Router>
      <Toaster position="top-right" toastOptions={{ duration: 3000 }} />
      <Routes>
        <Route path="/login" element={!isAuthenticated ? <LoginPage /> : <Navigate to="/" replace />} />
        <Route path="/" element={<ProtectedRoute><Layout /></ProtectedRoute>}>
          <Route index element={<Dashboard />} />
          <Route path="medicines" element={<MedicinesPage />} />
          <Route path="inventory" element={<InventoryPage />} />
          <Route path="purchases" element={<PurchasesPage />} />
          <Route path="purchase-requests" element={<PurchaseRequestsPage />} />
          <Route path="requisitions" element={<RequisitionsPage />} />
          <Route path="sales" element={<SalesPage />} />
          <Route path="customers" element={<CustomersPage />} />
          <Route path="suppliers" element={<SuppliersPage />} />
          <Route path="patients" element={<PatientsPage />} />
          <Route path="employees" element={<EmployeesPage />} />
          <Route path="prescriptions" element={<PrescriptionsPage />} />
          <Route path="branches" element={<BranchesPage />} />
          <Route path="users" element={<UsersPage />} />
          <Route path="roles" element={<RolesPage />} />
          <Route path="accounting" element={<AccountingPage />} />
          <Route path="partners" element={<PartnersPage />} />
          <Route path="bank-accounts" element={<BankAccountsPage />} />
          <Route path="expenses" element={<ExpensesPage />} />
          <Route path="reports" element={<ReportsPage />} />
          <Route path="audit" element={<AuditPage />} />
          <Route path="master-data" element={<MasterDataPage />} />
          <Route path="settings" element={<SettingsPage />} />
        </Route>
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </Router>
  );
}

export default App;
